import { queryOptions } from '@tanstack/react-query';

import type { AccessToken } from '@/lib/tokenStorage';

import { type PaginationResult } from '../types';

export type SemenSorterDto = {
  id: string;
  isActive: boolean;
  name: string;
  siteId: string | null;
  site: {
    id: string;
    name: string;
  } | null;
};

type SemenSorterParams = {
  take: number;
  siteId: string;
};

async function fetchSemenSorters(
  token: AccessToken,
  params: SemenSorterParams,
): Promise<PaginationResult<SemenSorterDto>> {
  if (!token) {
    throw new Error('No access token available. Please log in.');
  }

  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
  if (
    !API_BASE_URL ||
    API_BASE_URL === 'undefined' ||
    API_BASE_URL === 'null'
  ) {
    throw new Error('VITE_API_BASE_URL is not defined or invalid');
  }

  const queryString = new URLSearchParams({
    take: params.take?.toString(),
    siteId: params.siteId,
    order: 'name',
  }).toString();
  const url = `${API_BASE_URL}/api/v1/semensorter${queryString ? `?${queryString}` : ''}`;

  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return (await response.json()) as PaginationResult<SemenSorterDto>;
}

export const semenSortersOptions = (
  token: AccessToken,
  params: SemenSorterParams,
) =>
  queryOptions({
    queryKey: ['semen-sorters', 'list', params],
    enabled: !!token,
    async queryFn() {
      return fetchSemenSorters(token, params);
    },
  });
